import React from "react";
import UnitCountTwo from "./child/UnitCountTwo";
import Balances2 from "./child/Balances2";
import BalanceLimit2 from "./child/BalanceLimit2";
import TradingFrequency2 from "./child/Tradingfrequency2";
const DashBoardLayerTwo = () => {
  return (
    <>
      <section>
        <div className="row gy-4 mt-4">
          <Balances2 />
          {/* <BalanceLimit2 />
          <TradingFrequency2 /> */}
        </div>
      </section>
    </>
  );
};

export default DashBoardLayerTwo;
